import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { jsx } from 'react/jsx-runtime';
import { Icon } from '@zapier/zinnia-icons';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { Button } from 'react-aria-components';

const iconButton = "_icon-button_1u64f_1";
const styles = {
	iconButton: iconButton
};

const sizeMap = {
  small: 20,
  medium: 24,
  large: 32
};
const IconButton = forwardRef((_a, ref) => {
  var { children, className, isDisabled = false, isSelected = false, name, size = "medium", style, variant = "primary" } = _a, props = __rest(_a, ["children", "className", "isDisabled", "isSelected", "name", "size", "style", "variant"]);
  const getContent = (buttonRenderProps) => {
    if (name) {
      return jsx(Icon, { "aria-hidden": true, name, shouldAnimateFill: false, size: sizeMap[size] });
    }
    if (typeof children === "function") {
      return children(buttonRenderProps);
    }
    if (!children) {
      console.warn("IconButton should be passed a `name` or `children` prop.");
      return null;
    }
    return children;
  };
  return jsx(Button, Object.assign({}, props, { ref, className: (renderProps) => {
    const dynamicClassName = typeof className === "function" ? className(renderProps) : className;
    return clsx(dynamicClassName, styles.iconButton);
  }, "data-selected": isSelected ? "true" : void 0, "data-variant": variant, "data-size": size, "data-zds": true, isDisabled, style, children: getContent }));
});

export { IconButton };
//# sourceMappingURL=IconButton.es.js.map
